/**
 * KTUI - Free & Open-Source Tailwind UI Components by Keenthemes
 * Copyright 2025 by Keenthemes Inc
 */

export { KTModal } from './modal';
export type { KTModalConfigInterface, KTModalInterface } from './types';
